import { safeLocalStorage } from 'Utilities/storages';

export const mileageExperimentFlag = {
  get: (vrm?: string): boolean => safeLocalStorage.getItem(`mileageRemoved${vrm}`) === 'true',
  remove: (vrm?: string): void => safeLocalStorage.removeItem(`mileageRemoved${vrm}`),
  set: (vrm: string): void => safeLocalStorage.setItem(`mileageRemoved${vrm}`, 'true'),
};
